import { ArrowRightIcon } from "@heroicons/react/24/outline";
import React from "react";
import { useNavigate } from "react-router-dom";

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="h-screen flex items-center justify-center bg-white">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-indigo-600">Oops! 404</h1>
        <p className="mt-4 text-2xl font-medium text-indigo-600">
          Looks like you've wandered off the trail!
        </p>
        <p className="mt-2 text-lg text-neutral-600 font-light">
          Don't worry, even the best adventurers get lost sometimes.
        </p>
        <div className="mt-8 space-y-4">
          <button
            onClick={() => navigate("/")}
            className="px-6 py-3 rounded-full bg-indigo-600 text-white hover:bg-indigo-700 transition-all duration-300 transform hover:scale-105 flex items-center justify-center mx-auto space-x-2"
          >
            <span>Head to Home</span>
            <ArrowRightIcon className="h-5 w-5 text-white" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
